import Title from "antd/es/typography/Title";
import React from "react";

interface PaymentRequestFormProps extends PaymentRequestSharedProps {
  completed: boolean;
}

interface PaymentRequestSharedProps {
  amount: number;
  reason: string;
}

const PaymentRequestResponded = (props: PaymentRequestSharedProps) => {
  return (
    <div>
    The applicant has responded to the request for {props.reason}
    <div
      style={{
        margin: "10px 5px",
        padding: "10px",
        color: "black",
        borderRadius: "8px",
        background: "#D2F9D2",
        textAlign: "center",
      }}
    >
      US${props.amount} Request
    </div>
  </div>
  )
};

const PaymentRequestPending = (props: PaymentRequestSharedProps) => {
  return (
    <div>
    <Title
      level={5}
      style={{
        marginBottom: 15,
      }}
    >
      Payment Requested
    </Title>
    <div
      style={{
        margin: "10px 5px",
        padding: "10px",
        color: "black",
        borderRadius: "8px",
        background: "#FFDBBB",
      }}
    >
      <b> Awaiting Applicant Response</b>
      <br></br>
      <br></br>
      <b>Payment:</b> US${props.amount}
      <br></br>
      <b>Reason: </b> "{props.reason}"
    </div>
  </div>
  )
};

export const PaymentRequestForm: React.FC<PaymentRequestFormProps> = (props) => {

  return (
    <div
      style={{
        backgroundColor: "white",
        paddingTop: "20px",
        paddingBottom: "20px",
        paddingLeft: "20px",
        paddingRight: "20px",
        margin: 10,
        textAlign: "left",
        border: "1px solid #d9d9d9",
        borderRadius: "8px",
      }}
    >
      {props.completed ? <PaymentRequestResponded {...props}/> : <PaymentRequestPending {...props} />}
    </div>
  );
};
